// Classes
import { MONSTERS } from "../../Classes/utils/constants";
// Store
import { MONSTERS_ACTIONS } from "../Actions/monstersActions";
import { POSITION_ACTIONS, STATS_ACTIONS, INVENTORY_ACTIONS } from "../Actions/utilsActions";
import { positionReducer, statsReducer, inventoryReducer } from "../Reducers/utilsReducer";
// Helpers
import { STATS_UPDATE_TYPE } from "../../Helpers/constants";
import { log } from "../../Helpers/logger";

export const monstersReducer = (state = MONSTERS, action) => {
    // log.reducer.log("monstersReducer", state, action);
    const { monsters } = state;
    switch (action.type) {
        
        case MONSTERS_ACTIONS.TRANSFER_BY_ID: {
            const { monsterId, actualZoneId, nextZoneId } = action.payload;
            //log.reducer.log("monstersReducer payload", action.payload);

            // Supprimer l'id du monstre situé dans 'actualZone'
            let nextActualZone = [
                ...state[actualZoneId],
            ]
            const index = nextActualZone.findIndex(id => id === monsterId)
            nextActualZone.splice(index, 1);

            // Ajouter l'id du monstre dans 'nextZone'
            let nextNextZone = [
                ...state[nextZoneId],
                monsterId
            ]

            // Mise à jour du state du store
            return {
                ...state,
                [actualZoneId]: nextActualZone,
                [nextZoneId]: nextNextZone
            }
        }
        case MONSTERS_ACTIONS.MOVE_BY_ID: {
            const { monsterId } = action.payload;
            const monster = state[monsterId];

            const nextMonster = {
                ...monster,
                position: positionReducer(monster.position, {
                    type: POSITION_ACTIONS.MOVE,
                    payload: action.payload
                })
            }

            return {
                ...state,
                [monsterId]: nextMonster
            }
        }
        case MONSTERS_ACTIONS.RENAME_BY_ID: {
            const { monsterId } = action.payload;
            const monster = state[monsterId];

            const nextMonster = {
                ...monster,
                name: action.payload.name
            }

            return {
                ...state,
                [monsterId]: nextMonster
            }
        }

        case MONSTERS_ACTIONS.CAST_SPELL_BY_ID: {
            const { monsterId } = action.payload;
            const monster = state[monsterId];
            log.reducer.log("cast spell", monster)
            const nextMonster = {
                ...monster,
                stats: statsReducer(monster.stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: action.payload
                })
            }

            return {
                ...state,
                [monsterId]: nextMonster
            }
        }
        
        case MONSTERS_ACTIONS.TAKE_DAMAGE_BY_ID: {
            const { monsterId, amount } = action.payload;
            const monster = state[monsterId];
            const { stats } = monster;

            let statsReducerPayload = [["health", STATS_UPDATE_TYPE.DECREMENT, amount, 0]];

            const nextMonster = {
                ...monster,
                stats: statsReducer(monster.stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: statsReducerPayload
                })
            }
           
            return {
                ...state,
                [monsterId]: nextMonster
            }
        }
        case MONSTERS_ACTIONS.USE_ITEM: {
            const { monsterId, slotIndex } = action.payload;
            const monster = state[monsterId];
            const { stats, inventory } = monster

            const item = monster.inventory[slotIndex];
            log.reducer.log(monster, item);

            if (!item) {
                // si le slot est égal à null, deja il y a erreur dans le code :
                // s'assurer de donner un slotIndex valide
                return state;
            }
            
            let statsReducerPayload = [];
            switch (item.effect.type) {
                case 'gainHP': {
                    statsReducerPayload = [
                        ...statsReducerPayload,
                        ['health', STATS_UPDATE_TYPE.INCREMENT, item.effect.value, stats['maxHealth']]
                    ];

                    break;
                }
                case 'gainMP': {
                    statsReducerPayload = [
                        ...statsReducerPayload,
                        ['mana', STATS_UPDATE_TYPE.INCREMENT, item.effect.value]
                    ];

                    break;
                }
                case 'gainHP/gainMP': {
                    statsReducerPayload = [
                        ...statsReducerPayload,
                        ['health', STATS_UPDATE_TYPE.INCREMENT, item.effect.value],
                        ['mana', STATS_UPDATE_TYPE.INCREMENT, item.effect.value],
                    ];

                    break;
                }
                default:
                    break;
            }
            log.reducer.log(statsReducerPayload);

            const nextMonster = {
                ...monster,
                stats: statsReducer(stats, {
                    type: STATS_ACTIONS.UPDATE,
                    payload: statsReducerPayload,
                }),
                inventory: inventoryReducer(inventory, {
                    type: INVENTORY_ACTIONS.USE_ITEM_BY_SLOT_INDEX,
                    payload: {
                        slotIndex
                    },
                })
            };

            return {
                ...state,
                [monsterId]: nextMonster
            }
        }
        // case MONSTERS_ACTIONS.ADD_IN_ZONE: {
        //     const { monsterId, zoneId } = action.payload
        //     log.reducer.log(monsterId, zoneId, state[zoneId])
        //     let nextZoneId = [
        //         ...state[zoneId],
        //         monsterId
        //     ]
        //     log.reducer.log(nextZoneId)

        //     return {
        //         ...state,
        //         [zoneId]: nextZoneId
        //     }
        // }

        default:
            break;
    }

    return state;
}
